import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var BulletListSvg = function BulletListSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M7.138 2H2v5.185h5.138zm-3.67 3.704V3.48H5.67v2.223z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "M10.073 5.333H22V3.852H10.073zM10.073 12.74H22v-1.48H10.073zM22 20.148H10.073v-1.481H22z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M2 9.407h5.138v5.186H2zm1.468 1.482v2.222H5.67V10.89zM7.138 16.815H2V22h5.138zm-3.67 3.703v-2.222H5.67v2.223z",
      clipRule: "evenodd"
    })]
  });
};
export var BulletList = function BulletList(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: BulletListSvg
  }));
};